export const courierListCollectionGuard = 'GET /statistics/courier/list';
export const courierDataGuard = 'POST /statistics/courier/data';
export const regionShipmentOrderCallDataGuard =
  'POST /statistics/region/shipment-delivery-data';
export const regionPickUpDataGuard =
  'POST /statistics/region/shipment-pickup-data';
